import React from 'react';
import { BlogSection } from '../../organisms/BlogSection/BlogSection';
import { MainContentWrapper } from './MainContent.Styles';
import {useIsDesktopOrLaptop, 
  useIsMiniNotebook, 
  useIsMobileBig, 
  useIsMobileMedium, 
  useIsMobileMini 
} from './../../../styles/theme';



interface MainContentProps {
  tag: string;
}

export const MainContent: React.FC<MainContentProps> = ({ tag }) => {
  console.log("Target Tag em MainContent:", tag);

  
      const breakpoints = {
        isDesktopFull: useIsDesktopOrLaptop(),
        isDesktopOrLaptop: useIsDesktopOrLaptop(),
        isMiniNotebook: useIsMiniNotebook(),
        isMobileBig: useIsMobileBig(),
        isMobileMedium: useIsMobileMedium(),
        isMobileMini: useIsMobileMini(),
      };

  return (
    <MainContentWrapper {...breakpoints}>
      <BlogSection  tag={tag} />
    </MainContentWrapper>
  );
};



